import { Component, Input, OnInit } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                  from '@uirouter/core';

import { CompanyService }          from '../companies/company.service';
import { CompanySettingsModel }    from '../companies/models/company.settings';
import { CustomerPortalService }   from './customer-portal.service';
import { MessagesService }         from '../messages/messages.service';

@Component({
  selector   : 'wor-customer-portal-settings',
  template: require('./customer-portal.settings.component.html')
})
export class CustomerPortalSettingsComponent implements OnInit {
  @Input() settings: CompanySettingsModel;

  hasIntegration: boolean;

  constructor (
    private companyService         : CompanyService,
    private customerPortalService  : CustomerPortalService,
    private messagesService        : MessagesService,
    private router                 : UIRouter,
    private translateService       : TranslateService
  ) {}

  ngOnInit (): void {


    this.hasIntegration = this.companyService.hasIntegration('customer-portal');


  }

  activate (): void {
    this.customerPortalService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_PORTAL.TITLE')
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  deactivate (): void {
    this.customerPortalService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_PORTAL.TITLE')
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }
}
